import { render, staticRenderFns } from "./PushRecord.vue?vue&type=template&id=be3378a8&scoped=true&"
import script from "./PushRecord.vue?vue&type=script&lang=js&"
export * from "./PushRecord.vue?vue&type=script&lang=js&"
import style0 from "./PushRecord.vue?vue&type=style&index=0&id=be3378a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3378a8",
  null
  
)

export default component.exports